module.exports = __webpack_public_path__ + "img/edge_divers_pratique_jaime_services.ab3a78f1.svg";